"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function cutText(text, countLetters, endText) {
    if (endText === void 0) { endText = '…'; }
    if (!text) {
        return text;
    }
    var textLength = text.length;
    if (textLength <= countLetters) {
        return text;
    }
    else {
        return "" + text.substr(0, countLetters).trim() + endText;
    }
}
exports.cutText = cutText;
//# sourceMappingURL=cutText.js.map